import { c as _c } from "react/compiler-runtime";
import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material';
export function Loading(t0) {
  const $ = _c(2);
  const {
    numberOfOffers
  } = t0;
  let t1;
  if ($[0] !== numberOfOffers) {
    t1 = <TableBody>{Array.from({
        length: numberOfOffers
      }, _temp)}</TableBody>;
    $[0] = numberOfOffers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(_, index) {
  return <TableRow key={index} data-testid="skeleton-row"><TableCell sx={{
      verticalAlign: "top"
    }}><Skeleton variant="rounded" width={155} height={100} /></TableCell><TableCell sx={{
      verticalAlign: "top"
    }}><Skeleton variant="rounded" width={120} height={80} /></TableCell><TableCell sx={{
      verticalAlign: "top"
    }}><Skeleton variant="rounded" width={50} height={45} /></TableCell><TableCell sx={{
      verticalAlign: "top"
    }}><Skeleton variant="rounded" width={60} height={45} /></TableCell><TableCell sx={{
      verticalAlign: "top"
    }}><Skeleton variant="rounded" width={60} height={45} /></TableCell><TableCell sx={{
      verticalAlign: "top",
      display: {
        xs: "none",
        md: "table-cell"
      }
    }}><Skeleton variant="rounded" width={120} height={90} /></TableCell></TableRow>;
}